import localKey from './localKey'

const devApiUrl = 'http://192.168.110.160:8906';

// const proApiUrl = 'https://a.api.fxzb.vip';
const proApiUrl = 'https://dev.a.api.fxzb.vip';
// const proApiUrl = 'http://192.168.110.201:8131';
// const proApiUrl = 'http://192.168.110.48:8113';

const nodeDevEnv = process.env.NODE_ENV == 'development' ? true : false;



export default {
    nodeDevEnv: nodeDevEnv,
    apiUrl: nodeDevEnv ? devApiUrl : proApiUrl,
    siteName: '服务商后台',
    minSiteMame: 'C',
    version: "v1.0.0",
    apiPrefix: "",
    timeout: 10000,
    cookiesExpires: 7,
    requestRetry: 4,
    requestRetryDelay: 800,
    tokenKey: 'Authorization',
    userInfoKey: 'USER_INFO',
    ...localKey
}
